import { FirestoreDataConverter } from '@angular/fire/firestore';

export class NestingTask {

  id: string;
  organizationId: string;
  transactionId: string;
  orderIds: string[];
  date: Date | null;
  endDate: Date | null;
  material: string;
  processed: boolean;
  withError: boolean;
  inProgress: boolean;
  imported: boolean;
  storagePaths: string[];
  error: string;
  importFailed: number;

  constructor(task?: Partial<NestingTask>) {
    this.id = task?.id ?? '';
    this.organizationId = task?.organizationId ?? '';
    this.transactionId = task?.transactionId ?? '';
    this.orderIds = task?.orderIds ?? [];
    this.date = task?.date ?? null;
    this.endDate = task?.endDate ?? null;
    this.material = task?.material ?? '';
    this.processed = task?.processed ?? false;
    this.withError = task?.withError ?? false;
    this.inProgress = task?.inProgress ?? false;
    this.imported = task?.imported ?? false;
    this.storagePaths = task?.storagePaths ?? [];
    this.error = task?.error ?? '';
    this.importFailed = task?.importFailed ?? 0;
  }

  static converter: FirestoreDataConverter<NestingTask> = {
    toFirestore: (task: NestingTask) => ({
      organizationId: task.organizationId,
      transactionId: task.transactionId,
      orderIds: task.orderIds,
      date: task.date,
      endDate: task.endDate,
      material: task.material,
      processed: task.processed,
      withError: task.withError,
      inProgress: task.inProgress,
      imported: task.imported,
      storagePaths: task.storagePaths,
      error: task.error,
      importFailed: task.importFailed,
    }),
    fromFirestore: (snapshot, options) => {
      const data = snapshot.data(options);
      return new NestingTask({
        ...data,
        id: snapshot.id,
        date: data['date'] ? new Date(data['date'].seconds * 1000) : null,
        endDate: data['endDate'] ? new Date(data['endDate'].seconds * 1000) : null,
      });
    }
  };
}
